/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventTooltipsActionsTooltip } from './IntegrationEventTooltipsActionsTooltip';
import {
    IntegrationEventTooltipsActionsTooltipFromJSON,
    IntegrationEventTooltipsActionsTooltipFromJSONTyped,
    IntegrationEventTooltipsActionsTooltipToJSON,
    IntegrationEventTooltipsActionsTooltipToJSONTyped,
} from './IntegrationEventTooltipsActionsTooltip';

/**
 * 
 * @export
 * @interface IntegrationEventTooltipsActions
 */
export interface IntegrationEventTooltipsActions {
    /**
     * 
     */
    enabled_buttons?: Array<IntegrationEventTooltipsActionsEnabledButtonsEnum>;
    /**
     * 
     */
    tooltip?: IntegrationEventTooltipsActionsTooltip;
    /**
     * 
     */
    confirmation?: IntegrationEventTooltipsActionsConfirmationEnum;
}


/**
 * @export
 */
export const IntegrationEventTooltipsActionsEnabledButtonsEnum = {
    Dismiss: 'dismiss',
    Apply: 'apply',
    MarkAsApplied: 'mark_as_applied',
} as const;
export type IntegrationEventTooltipsActionsEnabledButtonsEnum = typeof IntegrationEventTooltipsActionsEnabledButtonsEnum[keyof typeof IntegrationEventTooltipsActionsEnabledButtonsEnum];

/**
 * @export
 */
export const IntegrationEventTooltipsActionsConfirmationEnum = {
    HospitalizedReadmit: 'hospitalized_readmit',
    BedConflict: 'bed_conflict',
    EndOfCareAdmissionTransition: 'end_of_care_admission_transition',
} as const;
export type IntegrationEventTooltipsActionsConfirmationEnum = typeof IntegrationEventTooltipsActionsConfirmationEnum[keyof typeof IntegrationEventTooltipsActionsConfirmationEnum];


/**
 * Check if a given object implements the IntegrationEventTooltipsActions interface.
 */
export function instanceOfIntegrationEventTooltipsActions(value: object): value is IntegrationEventTooltipsActions {
    return true;
}

export function IntegrationEventTooltipsActionsFromJSON(json: any): IntegrationEventTooltipsActions {
    return IntegrationEventTooltipsActionsFromJSONTyped(json, false);
}

export function IntegrationEventTooltipsActionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventTooltipsActions {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled_buttons': json['enabled_buttons'] == null ? undefined : json['enabled_buttons'],
        'tooltip': json['tooltip'] == null ? undefined : IntegrationEventTooltipsActionsTooltipFromJSON(json['tooltip']),
        'confirmation': json['confirmation'] == null ? undefined : json['confirmation'],
    };
}

export function IntegrationEventTooltipsActionsToJSON(json: any): IntegrationEventTooltipsActions {
    return IntegrationEventTooltipsActionsToJSONTyped(json, false);
}

export function IntegrationEventTooltipsActionsToJSONTyped(value?: IntegrationEventTooltipsActions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled_buttons': value['enabled_buttons'],
        'tooltip': IntegrationEventTooltipsActionsTooltipToJSON(value['tooltip']),
        'confirmation': value['confirmation'],
    };
}

